import { type ButtonHTMLAttributes, forwardRef } from 'react';
import { cx } from './cx';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg' | 'xl';

const VARIANT: Record<ButtonVariant, string> = { primary: 'pri', secondary: '', ghost: 'gh', danger: 'dng' };
const SIZE: Record<ButtonSize, string> = { sm: 'sm', md: '', lg: 'lg', xl: 'xl' };

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Square, icon only (needs aria-label). */
  icon?: boolean;
}

/** S30 «Bottoni»: primary, secondary, ghost, destructive, disabled; small, normal, large (phone), icon-only. */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', size = 'md', icon = false, className, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx('btn', VARIANT[variant], SIZE[size], icon && 'ic', className)}
      {...rest}
    />
  );
});
